"use strict";

import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
import classNames from "classnames";
import React, { useState } from "react";
import { Transition } from "react-transition-group";
import { Tick, IconSize, ListMarkerSquare, Warning } from "../../icons";
import { forceReflow } from "../../../utils";
import { darkTheme, duration, lightTheme } from "../../../tokens/tokens-css";
import { Label } from "../Label";
import * as styles from "./Checkbox-css";
import Tooltip from "../Tooltip/Tooltip";
import { Expandable } from "../../behaviors/Expandable";
import { Text } from "../Text";
export function Checkbox(_a) {
  var _classNames;
  var _b = _a,
    _b$size = _b.size,
    size = _b$size === void 0 ? "s" : _b$size,
    theme = _b.theme,
    id = _b.id,
    label = _b.label,
    checked = _b.checked,
    disabled = _b.disabled,
    labelHidden = _b.labelHidden,
    role = _b.role,
    onChange = _b.onChange,
    onFocus = _b.onFocus,
    onBlur = _b.onBlur,
    className = _b.className,
    tooltip = _b.tooltip,
    error = _b.error,
    props = __objRest(_b, ["size", "theme", "id", "label", "checked", "disabled", "labelHidden", "role", "onChange", "onFocus", "onBlur", "className", "tooltip", "error"]);
  var _useState = useState(void 0),
    _useState2 = _slicedToArray(_useState, 2),
    showTooltip = _useState2[0],
    setShowTooltip = _useState2[1];
  var checkboxId = "checkbox-".concat(id);
  var labelId = "checkbox-".concat(id, "-label");
  var tooltipId = "checkbox-".concat(id, "-tooltip");
  var errorId = "checkbox-".concat(id, "-error");
  var handleChange = function handleChange(event) {
    onChange(!checked, id, event);
  };
  var renderCheckbox = function renderCheckbox() {
    return /* @__PURE__ */React.createElement("button", {
      className: styles.checkbox,
      onClick: handleChange,
      role: role != null ? role : "checkbox",
      "aria-labelledby": labelId,
      "aria-checked": checked,
      "aria-disabled": disabled,
      "aria-describedby": error ? errorId : void 0,
      "aria-invalid": !!error,
      disabled: disabled,
      onFocus: onFocus,
      onBlur: onBlur,
      id: checkboxId,
      type: "button"
    }, /* @__PURE__ */React.createElement(Transition, {
      mountOnEnter: true,
      unmountOnExit: true,
      in: checked === true,
      timeout: duration.m,
      onEnter: forceReflow
    }, function (status) {
      return /* @__PURE__ */React.createElement(Tick, {
        className: styles.indicator({
          visible: ["entering", "entered"].includes(status)
        }),
        size: IconSize.Small
      });
    }), /* @__PURE__ */React.createElement(Transition, {
      mountOnEnter: true,
      unmountOnExit: true,
      in: checked === "mixed",
      timeout: duration.m,
      onEnter: forceReflow
    }, function (status) {
      return /* @__PURE__ */React.createElement(ListMarkerSquare, {
        className: styles.indicator({
          visible: ["entering", "entered"].includes(status)
        }),
        size: IconSize.Small
      });
    }));
  };
  return /* @__PURE__ */React.createElement("div", {
    className: classNames(styles.container, (_classNames = {}, _defineProperty(_classNames, lightTheme, theme === "light"), _defineProperty(_classNames, darkTheme, theme === "dark"), _classNames), className)
  }, /* @__PURE__ */React.createElement("div", __spreadValues({
    className: styles.content({
      disabled: disabled,
      size: size
    }),
    onMouseEnter: function onMouseEnter() {
      return setShowTooltip(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setShowTooltip(false);
    },
    onFocus: function onFocus() {
      return setShowTooltip(true);
    },
    onBlur: function onBlur() {
      return setShowTooltip(false);
    },
    tabIndex: disabled ? 0 : void 0,
    "aria-describedby": disabled ? tooltipId : void 0
  }, props), !tooltip && renderCheckbox(), !!tooltip && /* @__PURE__ */React.createElement(Tooltip, __spreadProps(__spreadValues({}, tooltip), {
    show: tooltip.show || showTooltip
  }), renderCheckbox()), /* @__PURE__ */React.createElement(Label, {
    long: true,
    disabled: disabled,
    hidden: labelHidden,
    className: styles.label({
      hidden: labelHidden
    }),
    element: "label",
    htmlFor: checkboxId,
    id: labelId
  }, label)), /* @__PURE__ */React.createElement(Expandable, {
    expanded: !!error,
    timeout: duration.s
  }, function (_ref) {
    var expandableElementRef = _ref.expandableElementRef;
    return /* @__PURE__ */React.createElement("div", {
      "aria-live": "polite",
      ref: expandableElementRef,
      id: errorId,
      className: styles.error
    }, /* @__PURE__ */React.createElement(Warning, {
      "aria-hidden": true,
      size: IconSize.Small,
      color: "critical",
      className: styles.errorIcon
    }), /* @__PURE__ */React.createElement(Text, {
      size: "s",
      lineHeight: "compact"
    }, error));
  }));
}